<template>
    <div class="ele-shop-search ele-container">
        <Header backType="none" :back="true" @goBack="goBack"></Header>
        <div class="shopSearchRow">
            <div class="smart-search-input">
                <Svgs color="#C0C4CD" class="input-search-icon" name="iconsousuo"></Svgs>
                <form action="javascript:return true">
                    <input
                        type="search"
                        placeholder="请输入餐厅名称"
                        @keyup.enter="eleSearch()"
                        v-model="keyword"
                    />
                </form>
            </div>
            <span class="searchCancel" @click="eleSearch">搜索</span>
        </div>
        <div class="search-history">
            <div class="search-title" v-show="hisData.length">
                历史记录
                <span class="shopSearchClear" @click="clearHis">
                    <Svgs color="#5B6C76" name="iconshanchu" />
                </span>
            </div>
            <div>
                <van-button
                    round
                    size="small"
                    v-for="txt in hisData"
                    :key="txt"
                    type="default"
                    @click="chooseTxt(txt)"
                >
                    {{ txt }}
                </van-button>
            </div>
        </div>
        <div class="search-brand">
            <div class="search-title">品牌推荐</div>
            <ul>
                <li
                    v-for="item in hotList"
                    :key="item.name"
                    @click="chooseHotItem(item)"
                >
                    <Svgs :name="item.icon"></Svgs>
                    {{ item.name }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            keyword: "",
            hisData: [],
            chooseKey: "",
            hotList: [
                {
                    icon: "iconxingbakelogo",
                    name: "星巴克",
                },
                {
                    icon: "iconmaidanglao",
                    name: "麦当劳",
                },
                {
                    icon: "iconkendeji",
                    name: "肯德基",
                },
            ],
        };
    },
    computed: {
        ...mapGetters(["eleKeyword", "eventData"]),
    },
    async mounted() {
        this.keyword = this.eleKeyword;
        let hisData = await this.nativeGet(this.getHisKey);
    },
    methods: {
        ...mapMutations(["ELE_KEYWORD", "IS_XINGBAKE"]),
        getHisKey(keyword) {
            this.hisData = keyword;
        },
        goBack() {
            this.$router.go(-1);
        },
        eleSearch() {
            if (!this.keyword) {
                this.$toast("请输入餐厅名称");
            } else {
                this["ELE_KEYWORD"](this.keyword);
                this["IS_XINGBAKE"](false);
                this.computeKeywords(this.keyword);
                this.goBack();
            }
        },
        chooseTxt(text) {
            this["ELE_KEYWORD"](text);
            this["IS_XINGBAKE"](false);
            this.computeKeywords(text);
            this.goBack();
        },
        chooseHotItem(item) {
            if (item.name == "星巴克") {
                this["IS_XINGBAKE"](true);
            } else {
                this["IS_XINGBAKE"](false);
            }
            this["ELE_KEYWORD"](item.name);
            this.goBack();
        },
        async computeKeywords(txt) {
            this.chooseKey = txt;
            let localKeys = await this.nativeGet(this.computeKey);
        },
        computeKey(localKeys) {
            let txt = this.chooseKey;
            let flag = true;
            for (let i = 0; i < localKeys.length; i++) {
                if (localKeys[i] == txt) {
                    localKeys.splice(i, 1);
                }
            }
            if (localKeys.length == 10) {
                localKeys.pop();
            }
            localKeys.unshift(txt);
            this.nativeSave(localKeys);
        },
        async clearHis() {
            this.nativeSave([]);
            let hisData = await this.nativeGet(this.getHisKey);
        },
        nativeSave: async function (params) {
            if (this.eventData.tenant_code == "eventcool") {
                localStorage.setItem("searchKeywords", JSON.stringify(params));
            } else {
                this.iJsBridge.call({
                    method: "SMDataStorage.setItem",
                    postData: { ["searchKeywords"]: JSON.stringify(params) },
                });
            }
        },
        nativeGet: async function (callBack) {
            let data = [];
            console.log('tenant',this.$cookies.get('tenant'));
            if (this.eventData.tenant_code == "eventcool") {
                data = JSON.parse(localStorage.getItem("searchKeywords")) || [];
                callBack(data);
            }
            if(this.$cookies.get('tenant') == 'crossevent'){
                return
            } else {
                this.iJsBridge.call({
                    method: "SMDataStorage.getItem",
                    postData: {
                        key: ["searchKeywords"],
                    },
                    callback: function (datas) {
                        callBack(
                            JSON.parse(
                                datas.searchKeywords
                                    ? datas.searchKeywords
                                    : "[]"
                            )
                        );
                    },
                });
            }
        },
    },
};
</script>
<style lang="scss">
@import "ShopSearch";
</style>